import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function BSHtmlNonBillableTasksStrategy() {}

BSHtmlNonBillableTasksStrategy.prototype = new BaseHTMLColumnStrategy();

BSHtmlNonBillableTasksStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlNonBillableTasksStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    this.addCell( row, this.message( "report.billing_summary.overall_spent.non_billible.html" ), "totalNonBillable", 1, levelsNumber );
};

BSHtmlNonBillableTasksStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    // do nothing
};

BSHtmlNonBillableTasksStrategy.prototype.addColumnValueCells = function ( row ) {
    this.addTimeValueCell(row);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlNonBillableTasksStrategy.js